import { CREDENTIALS_UPDATE_BOTTOM_BAR_CLASS_NAME } from '../../constants/toolbar';
import NAVBAR_HEIGHT from '../constants/navbar';

export const credentialsUpdateBottomBarClassName = ({ theme, backgroundColor }) => ({
  zIndex:1300,
  position: "sticky",
  bottom: 0,
  minHeight: 70,
  backgroundColor: backgroundColor,
});


const MuiToolbar = {
  navbarHeight: NAVBAR_HEIGHT,
  styleOverrides: {
    root: ({ theme }) => ({
      minHeight: 0,
      [theme.breakpoints.up('xs')]: {
        minHeight: 0,
      },
      [`&.${CREDENTIALS_UPDATE_BOTTOM_BAR_CLASS_NAME}`]: credentialsUpdateBottomBarClassName({ 
        theme, 
        backgroundColor: theme.palette.primary.main }),
    }),
  },
};

export default MuiToolbar;
